let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lKa7i")).then(() => parcelRequire('3fixv'));